import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { IPaymentRequirementFeeAdjustment } from '../../models/credential/scenarioRequirementDefinition.model';

@Component({
  selector: 'requirement-fee-adjustment-table',
  templateUrl: './requirement-fee-adjustment-table.component.html',
  styleUrls: ['./requirement-fee-adjustment-table.component.scss'],
})
export class RequirementFeeAdjustmentTableComponent implements OnInit {
  @Input() set data(value: IPaymentRequirementFeeAdjustment[]) {
    if (value) {
      this.dataSource = new MatTableDataSource<IPaymentRequirementFeeAdjustment>(value);
      this.sortFeeAdjustments();
    }
  }
  @Output() edit: EventEmitter<number> = new EventEmitter<number>();
  @Output() delete: EventEmitter<number> = new EventEmitter<number>();

  @Input()
  isLinksHidden: boolean = false;

  static allColumns: string[] = ['ledgerCode', 'fee', 'description', 'starts', 'ends', 'links'];
  static noLinkColumn: string[] = ['ledgerCode', 'fee', 'description', 'starts', 'ends'];

  get displayedColumns(): string[] {
    return this.isLinksHidden
      ? RequirementFeeAdjustmentTableComponent.noLinkColumn
      : RequirementFeeAdjustmentTableComponent.allColumns;
  }

  dataSource = new MatTableDataSource<IPaymentRequirementFeeAdjustment>([]);
  ngOnInit(): void {}

  onEditFeeAdjustment(index: number) {
    this.edit.emit(index);
  }

  onDeleteFeeAdjustment(index: number) {
    this.delete.emit(index);
  }

  private sortFeeAdjustments() {
    this.dataSource.data.sort((a, b) => {
      // First, compare based on 'type'
      if (a.starts.operator === 'Before' && b.starts.operator === 'After') {
        return -1; // 'Before' comes before 'After'
      } else if (a.starts.operator === 'After' && b.starts.operator === 'Before') {
        return 1; // 'After' comes after 'Before'
      }

      // If both are the same type as 'Before'
      if (a.starts.operator === 'Before' && b.starts.operator === 'Before') {
        return b.starts.days - a.starts.days;
      }
      // If both are the same type as 'After'
      return a.starts.days - b.starts.days;
    });
  }
}
